import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
export default class RemoveFriendConfirmModal extends Modal {
  loading = false;
  className() {
    return 'FriendshipConfirmModal Modal--small';
  }
  title() {
    return app.translator.trans('forumaker-friendship.forum.remove_modal.title');
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, m("p", {
      className: "FriendshipConfirmModal-text"
    }, app.translator.trans('forumaker-friendship.forum.remove_modal.text', {
      user: this.attrs.user
    })), m("div", {
      className: "FriendshipConfirmModal-actions"
    }, m(Button, {
      className: "Button Button--danger Button--block",
      icon: "fas fa-user-minus",
      loading: this.loading,
      onclick: () => this.remove()
    }, app.translator.trans('forumaker-friendship.forum.remove_modal.confirm_btn')), m(Button, {
      className: "Button Button--block",
      disabled: this.loading,
      onclick: () => this.hide()
    }, app.translator.trans('forumaker-friendship.forum.remove_modal.cancel_btn'))));
  }
  async remove() {
    this.loading = true;
    m.redraw();
    try {
      if (this.attrs.friendship) {
        await this.attrs.friendship.delete();
      } else {
        await app.request({
          method: 'POST',
          url: `${app.forum.attribute('apiUrl')}/friendships/remove`,
          body: {
            userId: this.attrs.user.id()
          }
        });
      }
      this.attrs.user.pushAttributes({
        friendshipIsFriend: false,
        friendCount: Math.max(0, (this.attrs.user.attribute('friendCount') || 0) - 1)
      });

      // No response body carries updated user resources for either removal
      // path, so the other side of the pair is decremented locally too —
      // friendship.user() when a specific row was loaded (FriendsPage,
      // possibly moderating someone else's list), otherwise the actor
      // (the profile dropdown only ever acts on its own relationship).
      const owner = this.attrs.friendship?.user() ?? app.session.user;
      owner?.pushAttributes({
        friendCount: Math.max(0, (owner.attribute('friendCount') || 0) - 1)
      });
      this.hide();
      this.attrs.onRemoved?.();
      app.alerts.show({
        type: 'success'
      }, app.translator.trans('forumaker-friendship.forum.remove_modal.success'));
    } catch (error) {
      this.loading = false;
      m.redraw();
      throw error;
    }
  }
}
flarum.reg.add('forumaker-friendship', 'forum/components/RemoveFriendConfirmModal', RemoveFriendConfirmModal);